import { useState, useEffect } from 'react';

export function useLayoutState() {
  const [layoutState, setLayoutState] = useState({
    isCondensed: false,
    isCollapsed: false,
  });

  useEffect(() => {
    const checkLayout = () => {
      const width = window.innerWidth;
      const isCondensed = width < 1024; // lg breakpoint
      
      setLayoutState(prev => ({
        ...prev,
        isCondensed
      }));
    };

    checkLayout();
    window.addEventListener('resize', checkLayout);
    
    return () => window.removeEventListener('resize', checkLayout);
  }, []);

  const updateCollapsedState = (isCollapsed: boolean) => {
    setLayoutState(prev => ({
      ...prev,
      isCollapsed
    }));
  };

  return { layoutState, updateCollapsedState };
}